const mutation = {
  initialReset(state) {
    state.list = [];
    state.listSoldTo = [];
    state.isLoading = false;
    state.isLoadingSoldTo = false;
    state.filter.page = 1;
    state.filterSoldTo.page = 1;
    state.hasEmpty = true;
    state.hasEmptySoldTo = true;
    state.masterVehiclesList = [];
    state.masterTransportersList = [];
  },

  resetListing(state) {
    state.list = [];
    state.isLoading = false;
    state.filter.page = 1;
    state.hasEmpty = true;
  },

  resetListingSoldTo(state) {
    state.listSoldTo = [];
    state.isLoadingSoldTo = false;
    state.filterSoldTo.page = 1;
    state.hasEmptySoldTo = true;
  },

  setSourceHasEmpty(state, data) {
    state.sourceHasEmpty = data;
  },
  setSourceList(state, data) {
    state.sourceList = data;
  },

  setDropsHasEmpty(state, data) {
    state.dropsHasEmpty = data;
  },
  addToList(state, data) {
    state.list.unshift(data);
  },

  setList(state, data) {
    if (data && data.length) {
      const result = (state.filter.page > 1) ?
        state.list.concat(data) : data;
      state.list = result;
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setIsLoading(state, data) {
    state.isLoading = data;
  },

  setListSoldTo(state, data) {
    if (data && data.length) {
      const result = (state.filterSoldTo.page > 1) ?
        state.listSoldTo.concat(data) : data;
      state.listSoldTo = result;
      state.filterSoldTo.page += 1;
      state.hasEmptySoldTo = false;
    } else {
      state.hasEmptySoldTo = true;
    }
  },
  setIsLoadingSoldTo(state, data) {
    state.isLoadingSoldTo = data;
  },

  setMasterVehiclesList(state, data) {
    state.masterVehiclesList = data;
  },

  setMasterTransportersList(state, data) {
    state.masterTransportersList = data;
  },
  setIsOrderProcessing(state, data) {
    state.isOrderProcessing = data;
  },
  setIndentBootstrap(state, data) {
    state.indentBootstrap = data;
  },
  setIsLrMandatoryForMarkAsDelivered(state, data) {
    state.isLrMandatoryForMarkAsDelivered = data;
  },
};

export default mutation;
